module.exports = __webpack_public_path__ + "media/Video 21a.6d943f95.mp4";